<template>
  <transition name="opacity">
    <div class="bar-loader">
      <div class="bar-loader--gradient"></div>
    </div>
  </transition>
</template>
<style>
.bar-loader {
  height: 2px;
  display: block;
  width: 100%;
  position: absolute;
  overflow: hidden;
  transition: opacity .5s;
  opacity: 1;

  &--gradient {
    width: 200vw;
    height: 2px;
    position: relative;
    background: linear-gradient(to right, white, var(--brand), var(--link-hover), white, var(--brand), var(--link-hover), white);

    animation: translateX 1s infinite linear;
  }
}

.l-section .bar-loader,
.Modal__body .bar-loader {
  top: 0; left: 0;
}

.opacity-enter-active, .opacity-leave {
  opacity: 1;
  transition: opacity .5s;
}

.opacity-enter, .opacity-leave-active {
  opacity: 0;
}

@keyframes translateX {
  from { transform: translateX(-100vw) }
  to { transform: translateX(0vw) }
}
</style>